import { useEffect } from 'react';
import { useLocation } from 'react-router-dom';
import Cookies from 'js-cookie';
import { trackAffiliateClick } from '@/services/api';

export const useReferralAttribution = () => {
  const location = useLocation();

  useEffect(() => {
    const params = new URLSearchParams(location.search);
    const refCode = params.get('ref');

    if (refCode) {
      // Set the cookie for 365 days, last-click attribution
      Cookies.set('indikin_ref', refCode, { expires: 365, path: '/' });

      // Track the click asynchronously without blocking
      trackAffiliateClick(refCode, {
        userAgent: navigator.userAgent,
        landingPath: location.pathname,
      }).catch((err) => {
        console.error('Failed to track affiliate click:', err);
      });
    }
  }, [location.search, location.pathname]);
};
